<div [ngStyle]="environment.theme.background" class="min-h-screen bg-[var(--primary-dark)] flex items-center justify-center p-3 md:p-4">
  <div class="w-full max-w-md bg-white rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.15)] overflow-hidden">

    <!-- Logo -->
    <div class="flex justify-center py-8 bg-[var(--background-registration)]">
      <img class="max-h-28 object-contain" [ngStyle]="environment.theme.logoStyling" [src]="environment.theme.logo" alt="Logo">
    </div>

    <!-- Content -->
    <div class="px-5 py-6 md:px-8 md:py-8">
      <div *ngIf="!userRefreshed">
        <p class="text-center text-[var(--base-text-alt-dark)] text-[15px] font-semibold mb-6">Please enter your details.</p>

        <form [formGroup]="loginForm" class="flex flex-col gap-4 text-left w-full max-w-[320px] mx-auto">
          <div>
            <label class="block text-[12px] font-medium text-[var(--base-text-alt-dark)] mb-1">Email</label>
            <input (keyup.enter)="sendCode()" type="email" formControlName="email" id="email" data-cy="email-input"
              placeholder="example@gmail.com"
              class="w-full px-3 py-2.5 border border-black rounded-lg text-[13px] text-black placeholder:text-gray-400 placeholder:italic outline-none focus:border-[var(--primary-dark)] focus:ring-1 focus:ring-[var(--primary-dark)] transition">
            <span *ngIf="loginForm.controls.email.touched && loginForm.controls.email.invalid"
              class="text-[var(--notification-error)] text-[10px] mt-1 block" data-cy="email-error">Required — Enter your email</span>
          </div>

          <div *ngIf="!shouldSendCode">
            <label class="block text-[12px] font-medium text-[var(--base-text-alt-dark)] mb-1">Password</label>
            <div class="relative">
              <input (keyup.enter)="login()" [type]="showPassword ? 'text' : 'password'" formControlName="password" id="password" data-cy="password-input"
                placeholder="••••••••"
                class="w-full px-3 py-2.5 border border-black rounded-lg text-[13px] text-black placeholder:text-gray-400 placeholder:italic outline-none focus:border-[var(--primary-dark)] focus:ring-1 focus:ring-[var(--primary-dark)] transition pr-10">
              <button type="button" (click)="showPassword = !showPassword" data-cy="password-visibility-toggle"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--base-text-alt-dark)] cursor-pointer bg-transparent border-none">
                <span class="material-icons text-[20px]">{{showPassword ? 'visibility_off' : 'visibility'}}</span>
              </button>
            </div>
            <span *ngIf="loginForm.controls.password.touched && loginForm.controls.password.hasError('required')"
              class="text-[var(--notification-error)] text-[10px] mt-1 block" data-cy="password-required-error">Required — Enter your password</span>
            <span *ngIf="loginForm.controls.password.hasError('pattern') && !loginForm.controls.password.hasError('minlength')"
              class="text-[var(--notification-error)] text-[10px] mt-1 block" data-cy="password-pattern-error">Must contain one special character, capital letter and number</span>
            <span *ngIf="loginForm.controls.password.hasError('minlength')"
              class="text-[var(--notification-error)] text-[10px] mt-1 block" data-cy="password-length-error">Must be at least 8 characters long</span>
          </div>

          <div *ngIf="needsNewPassword && !shouldSendCode">
            <label class="block text-[12px] font-medium text-[var(--base-text-alt-dark)] mb-1">Confirm Password</label>
            <div class="relative">
              <input (keyup.enter)="createNewPassword()" [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
                id="confirmPassword" data-cy="confirm-password-input" placeholder="••••••••"
                class="w-full px-3 py-2.5 border border-black rounded-lg text-[13px] text-black placeholder:text-gray-400 placeholder:italic outline-none focus:border-[var(--primary-dark)] focus:ring-1 focus:ring-[var(--primary-dark)] transition pr-10">
              <button type="button" (click)="showConfirmPassword = !showConfirmPassword" data-cy="confirm-password-visibility-toggle"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--base-text-alt-dark)] cursor-pointer bg-transparent border-none">
                <span class="material-icons text-[20px]">{{showConfirmPassword ? 'visibility_off' : 'visibility'}}</span>
              </button>
            </div>
            <span *ngIf="loginForm.get('confirmPassword')?.invalid && loginForm.get('confirmPassword')?.touched"
              class="text-[var(--notification-error)] text-[10px] mt-1 block" data-cy="confirm-password-error">Passwords must match</span>
          </div>
        </form>

        <p *ngIf="errorMessage" class="text-center text-[var(--notification-error)] text-[11px] mt-3" data-cy="error-message">{{errorMessage}}</p>

        <div *ngIf="!shouldSendCode" class="flex items-center justify-center gap-4 mt-6">
          <button class="border border-[var(--primary-dark)] text-[var(--primary-dark)] bg-white font-semibold py-2 px-6 rounded-lg text-[12px] cursor-pointer"
            routerLink="" type="button" id="cancel-btn" data-cy="cancel-button">Cancel</button>
          <button *ngIf="!needsNewPassword" class="bg-[var(--primary-dark)] text-white font-semibold py-2 px-6 rounded-lg text-[12px] cursor-pointer border-none"
            type="submit" (click)="login()" id="login-btn" data-cy="login-button">Login</button>
          <button *ngIf="needsNewPassword" class="bg-[var(--primary-dark)] text-white font-semibold py-2 px-6 rounded-lg text-[12px] cursor-pointer border-none"
            type="submit" (click)="createNewPassword()" data-cy="create-password-button">Login</button>
        </div>

        <p *ngIf="forgotPasswordIssue" class="text-center text-[var(--notification-error)] text-[11px] mt-3" data-cy="forgot-password-error">There was an issue processing the request</p>

        <div *ngIf="shouldSendCode" class="flex items-center justify-center gap-4 mt-6">
          <button class="border border-[var(--primary-dark)] text-[var(--primary-dark)] bg-white font-semibold py-2 px-6 rounded-lg text-[12px] cursor-pointer"
            (click)="toggleForgotPassword()" type="button" data-cy="forgot-password-cancel-button">Cancel</button>
          <button class="bg-[var(--primary-dark)] text-white font-semibold py-2 px-6 rounded-lg text-[12px] cursor-pointer border-none"
            type="submit" (click)="sendCode()" data-cy="send-code-button">Send Code</button>
        </div>

        <div *ngIf="!shouldSendCode" class="text-center mt-5">
          <span class="text-[var(--primary-dark)] text-[12px] font-semibold cursor-pointer" (click)="toggleForgotPassword()"
            id="forgot-password-link" data-cy="forgot-password-link">Forgot Password?</span>
        </div>
      </div>

      <div *ngIf="userRefreshed" class="text-center">
        <p class="text-[var(--base-text-alt-dark)] text-[14px] leading-relaxed mt-6 max-w-[320px] mx-auto">
          A Temporary Password was sent to your email: {{email}}. Please go back to the Login Page and try again.
        </p>
        <p class="mt-4 text-[var(--primary-dark)] text-[13px] font-semibold cursor-pointer" (click)="userRefreshed=false;toggleForgotPassword()">Back to Login</p>
      </div>
    </div>
  </div>
</div>
